import { AssigneeProps, Task } from 'types'

// helpers.ts (or inside useUniversalNotify file)
type RouteBase = 'teamtasks' | 'projects'

export const detectRouteBase = (pathname: string): RouteBase =>
  pathname.startsWith('/projects') ? 'projects' : 'teamtasks'

export const baseTitle = (base: RouteBase) => (base === 'projects' ? 'Projects' : 'Team Tasks')

export const buildTaskUrlRelative = (base: RouteBase, pk: string, sk: string) => `/${base}/${pk}/${sk}/main`

export const buildTaskUrlAbsolute = (baseOrigin: string, base: RouteBase, pk: string, sk: string) =>
  `${baseOrigin}${buildTaskUrlRelative(base, pk, sk)}`

export const baseListUrlRelative = (base: RouteBase) => `/${base}`
export const baseListUrlAbsolute = (baseOrigin: string, base: RouteBase) => `${baseOrigin}${baseListUrlRelative(base)}`

type TaskRef = { PK: string; SK: string; name?: string }

export const routeBaseForTask = (t: Partial<Task>): RouteBase => (t?.isCreative ? 'projects' : 'teamtasks') // default to teamtasks when in doubt

function extractAssigneeId(a: string | AssigneeProps | null | undefined): string | null {
  if (!a) return null
  if (typeof a === 'string') return a.trim() || null
  return a.user_uuid?.trim() || a.id?.trim() || a.slackId?.trim() || null
}

function normalizeAssignees(list?: Array<string | AssigneeProps> | null): string[] {
  if (!Array.isArray(list)) return []
  const out: string[] = []
  for (const item of list) {
    const id = extractAssigneeId(item)
    if (id) out.push(id)
  }
  return out
}

/** Build { [routeBase]: { [userId]: TaskRef[] } } */
export function buildAssignmentsByRouteBase(tasks: Task[] = []) {
  const out: Record<RouteBase, Record<string, TaskRef[]>> = {
    teamtasks: {},
    projects: {},
  }

  for (const t of tasks) {
    const base = routeBaseForTask(t)
    const ref: TaskRef = { PK: t.PK, SK: t.SK, name: t.name }

    // ✅ always a string[]
    const assigneeIds = normalizeAssignees(t.assignees as any)

    for (const uid of assigneeIds) {
      if (!uid) continue
      if (!out[base][uid]) out[base][uid] = []
      if (!out[base][uid].some(r => r.PK === ref.PK && r.SK === ref.SK)) {
        out[base][uid].push(ref)
      }
    }
  }
  return out
}
